import { render, staticRenderFns } from "./QuestionsHeader.vue?vue&type=template&id=7dfec19e&scoped=true"
import script from "./QuestionsHeader.vue?vue&type=script&lang=js"
export * from "./QuestionsHeader.vue?vue&type=script&lang=js"
import style0 from "./QuestionsHeader.vue?vue&type=style&index=0&id=7dfec19e&prod&lang=scss&scoped=true"
import style1 from "./QuestionsHeader.vue?vue&type=style&index=1&id=7dfec19e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfec19e",
  null
  
)

export default component.exports